import React, { memo } from 'react';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { ParameterConnectionsPinProps } from 'ducks/types/prop-types';

import cn from 'modals/parameter-connections/component/Components.module.scss';

const PinBase = ({
  status,
  classId,
  handleCreateConnection,
  pinParams,
  left,
  owner_id,
}: ParameterConnectionsPinProps) => {
  if (status === false && handleCreateConnection) {
    return (
      <div className={classNames(cn.pinWrapper, cn.creator)} onClick={() => handleCreateConnection(owner_id)}>
        <div className={cn.circle}>
          <FontAwesomeIcon icon={faPlus} />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={classNames(cn.pinWrapper, cn.pinWrapperCircle)}>
        <div
          className={classNames(cn.circleConnect, classId)}
          style={{
            right: !left ? '-6px' : '',
            left: left ? '-6px' : '',
          }}
        />
        <span className={cn.pinName}>{pinParams?.parameter_name}</span>
      </div>
    </>
  );
};

export const Pin = memo(PinBase);
